import React, { Component } from 'react';
import Header from '.././Header';
import classnames from 'classnames';
import './style.sass';

class Summary extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;
    const angellistLink = (
      <a href="https://angel.co">
        @AngelList
      </a>
    );
    const quoraLink = (
      <a href="https://quora.com">
        @Quora
      </a>
    );

    return (
      <div className={classnames('Summary', className)}>
        <h1 className="Summary-headline">
          Kah Hong Tay
        </h1>
        <h2 className="Summary-title">
          Product and Design {angellistLink}
        </h2>
        <p className="Summary-subtitle">
          I design, build and ship products for a marketplace of recruiting startups and job seekers.
        </p>
        <h2 className="Summary-title">
          Previously {quoraLink}
        </h2>
        <p className="Summary-subtitle">
          I spent three years as a product designer at Quora after joining as the first product design intern.
        </p>
        <h2 className="Summary-title">
          Passionate about products, startups and communities
        </h2>
        <p className="Summary-subtitle">
          My past endeavors include building a mobile survey tool for businesses, running a microblogging service, organizing startup panels at Stanford University, and bringing the bay area Singaporean tech community closer.
        </p>
      </div>
    );
  }
}

export default Summary;



// WEBPACK FOOTER //
// ./src/components/Summary/index.js